// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6dc3647a","453":"03fc493f","455":"c7c26ffa"}[chunkId] + ".chunk.js";
};